import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../features/projects/projectApi";
import { useAddTaskMutation } from "../features/tasks/taskApi";
import { useGetTeamsQuery } from "../features/teams/teamApi";

const AddTask = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    taskName: "",
    teamMember: "",
    project: "",
    deadline: "",
  });

  const { data: teams } = useGetTeamsQuery();
  const { data: projects } = useGetProjectsQuery();

  const [addTask, { isLoading, isSuccess }] = useAddTaskMutation();

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      taskName: state.taskName,
      teamMember: teams.find((team) => team.name == state.teamMember),
      project: projects.find((project) => project.projectName == state.project),
      deadline: state.deadline,
      status: "pending",
    };
    addTask(data);
    navigate("/");
  };
  // useEffect(() => {
  //   if (isSuccess) {
  //     navigate("/");
  //   }
  // }, [isSuccess, navigate]);
  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>
        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={state.taskName}
                onChange={(e) =>
                  setState({ ...state, taskName: e.target.value })
                }
              />
            </div>
            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                name="teamMember"
                id="lws-teamMember"
                required={true}
                value={state.teamMember}
                onChange={(e) =>
                  setState({ ...state, teamMember: e.target.value })
                }
              >
                <option value hidden selected>
                  Select Job
                </option>
                <option>Sumit Saha</option>
                <option>Saad Hasan</option>
                <option>Akash Ahmed</option>
                <option>Md Salahuddin</option>
                <option>Riyadh Hassan</option>
                <option>Ferdous Hassan</option>
                <option>Arif Almas</option>
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select
                id="lws-projectName"
                name="projectName"
                required
                value={state.project}
                onChange={(e) =>
                  setState({ ...state, project: e.target.value })
                }
              >
                <option value hidden selected>
                  Select Project
                </option>
                <option>Scoreboard</option>
                <option>Flight Booking</option>
                <option>Product Cart</option>
                <option>Book Store</option>
                <option>Blog Application</option>
                <option>Job Finder</option>
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={state.deadline}
                onChange={(e) =>
                  setState({ ...state, deadline: e.target.value })
                }
              />
            </div>
            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddTask;
